import {actionCreatorFactory} from 'typescript-fsa';
import { Firebase } from '../../remote/firebase';
import { AuthUser } from '../reducers/firebase-reducer';
import { ITSUser } from '../../types/user';
import { ClassroomStudents } from '@/types/classroom';

const actionCreator = actionCreatorFactory('FIREBASE');

export const initializeFirebase = actionCreator('INITIALIZE_FIREBASE');

export const firebaseInitialized = actionCreator<Firebase>('INITIALIZED');

export const updateAuthUserAction = actionCreator<AuthUser>('UPDATE_AUTH_USER');

export const updateCurrentUser = actionCreator<ITSUser | undefined>(
  'UPDATE_CURRENT_USER'
);

export const updateCurrentUserUnsubscribe = actionCreator<firebase.Unsubscribe>(
  'UPDATE_CURRENT_USER_UNSUBSCRIBE'
);

export const initAuthUnsubscribeAction =
  actionCreator<firebase.Unsubscribe>('AuthUnsubscribe');

export const cancelSignInRedirect = actionCreator('CANCEL_SIGN_IN_REDIRECT');

export const showInitialTour = actionCreator('SHOW_INITIAL_TOUR')

export const setStudentRoleOverride = actionCreator<boolean>('SET_STUDENT_ROLE_OVERRIDE')

export type RosterUpdatePayload = {
  roster: ClassroomStudents;
  isLTI: boolean;
};

/**
 * Update to the student roster (should only happen when in the teacher view).
 * Note that this can include student stats.
 */
export const updateRoster = actionCreator<RosterUpdatePayload>('UPDATE_ROSTER');

export const signOut = actionCreator('SIGN_OUT');